<div id="login" appAppPerfectScrollbar>
    <div id="login-form-wrapper">
        <div id="login-form" appIfOnDom [@animate]="{
                value: '*',
                params: { duration: '300ms', x: '-50px' }
            }">
            <div class="logo">
                <img src="../../../../../assets/images/sendo/Marca.svg" style="width: 200px; height: 200px" />
            </div>
            @if (isTokenValid) {
            <div>

                <form name="loginForm" [formGroup]="resetForm" novalidate>
                    <div>
                        @if(hasError){
                        <div class="mb-100">
                            <div class="alert alert-danger alert-padding">
                                <span class="fs-4">{{message}}</span>
                            </div>
                        </div>
                        }
                        <div class="">
                            <mat-label>{{ "Contraseña" | translate }}*
                            </mat-label>
                            <mat-form-field appearance="outline" class="w-100-p">
                                <input matInput (focus)="showPolicy()" autocomplete="off" (blur)="hidePolicy()"
                                    (input)="showPolicy()" placeholder="Contraseña" [type]="hide ? 'password' : 'text'"
                                    formControlName="password" />
                                <button mat-icon-button matSuffix (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <mat-icon id="hidePassword">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                            </mat-form-field>
                            @if (policy) {
                            <div class="password-policy">
                                <p>La contraseña debe cumplir con las siguientes políticas:</p>
                                <ul>
                                    <li>Al menos 8 caracteres de longitud</li>
                                    <li>Incluir una letra mayúscula</li>
                                    <li>Incluir una letra minúscula</li>
                                    <li>Incluir un número</li>
                                    <li>{{"Incluir un carácter especial (@, #, $, etc.)"}}</li>
                                </ul>
                            </div>
                            }
                            @if(isControlValid(resetForm, "password")){
                            <div class="text-danger ng-mt-2">
                                {{ getErrorMessage(resetForm, "password", "Contraseña") }}
                            </div>
                            }
                        </div>
                        <div>
                            <mat-label>{{ "Confirmar contraseña" | translate }}*</mat-label>
                            <mat-form-field appearance="outline" class="w-100-p">
                                <input matInput placeholder="Confirmar contraseña"
                                    [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword" />
                                <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirm">
                                    <mat-icon id="hidePassword">{{hideConfirm ? 'visibility_off' :
                                        'visibility'}}</mat-icon>
                                </button>
                            </mat-form-field>
                            @if(isControlValid(resetForm, "confirmPassword")){
                            <div class="text-danger ng-mt-2">
                                {{ getErrorMessage(resetForm, "confirmPassword", "Confirmar contraseña") }}
                            </div>
                            }
                        </div>
                    </div>
                    <div class="login-buttons-container">
                        <button mat-raised-button class="submit-button" aria-label="LOG IN" [disabled]="disableButton()"
                            (click)="resetPassword()">
                            <i *ngIf="isWaiting" style="font-size: 21px; color: white !important"
                                class="fa fa-refresh fa-spin"></i>
                            <div fxLayoutAlign="center center" *ngIf="!isWaiting">
                                <span class="button-logo material-symbols-outlined">
                                    lock
                                </span>
                                <span>Cambiar contraseña</span>
                            </div>
                        </button>
                    </div>
                    <div class="mt-5">
                        <a class="fs-3 link" translate [routerLink]="'/login'">Ingresar</a>
                    </div>
                </form>
            </div>
            }

            @if (!isTokenValid) {
            <div class="error-message-container">
                <div class="error-message d-flex flex-column">
                    <div class="alert alert-error d-flex flex-column">
                        <span class="fs-4">Oops! El token de recuperación no es válido</span>
                    </div>
                </div>
            </div>
            }

        </div>
    </div>
</div>